export const compareCalls = (firstValue: boolean | null, secondValue: boolean | null) => {
  const rank = (value: boolean | null) => (value === false ? 0 : value === true ? 1 : 2);

  return rank(firstValue) - rank(secondValue);
};
